import * as React from 'react';

import Box from '@mui/material/Box';

function Footer(){
    return (
        <footer className='footer'>
            <Box className='content'>
                <a className='logo' href='https://www.sea.com/home' />
                <Box className='links'>
                <Box className='wrapper'>
                    <a className='item' href='https://www.sea.com/home'>Company</a>
                </Box>
                <Box className='wrapper'>
                    <a className='item' href='https://www.sea.com/careers'>Careers</a>
                </Box>
                <Box className='wrapper info'>
                    <a className='item' href='#FAQ'>FAQ</a>
                </Box>
                </Box>
            </Box>
            <Box className='copyright'>
                <span>Copyright © Sea Limited. Trademarks belong to their respective owners. All rights reserved.</span>
                <a className='link' href='https://www.sea.com/terms'>Terms of Service </a>
                <a className='link' href='https://www.sea.com/privacy'>Privacy Policy</a>
            </Box>
        </footer>
    );
}
export default Footer;